import "../styles/QuoteHeader.css";

/*
const STATUS_STEPS = [
  { key: "pending", label: "Aguardando aprovação" },
  { key: "approved", label: "Aprovado" },
  { key: "awaiting_appointment", label: "Aguardando agendamento" },
  { key: "repairing", label: "Em reparo" },
  { key: "finished", label: "Finalizado" }
];

const normalizeStatus = (status, carWorkshopStatus) => {
  const normalized = String(status).toLowerCase();
  if (normalized === "finished") {
    return "finished";
  }

  if (normalized === "approved" && carWorkshopStatus !== "repairing" && carWorkshopStatus !== "awaiting_appointment") {
    return "approved";
  }

  if (normalized === "approved" && carWorkshopStatus === "repairing") {
    return "repairing";
  }

  if (normalized === "approved" && carWorkshopStatus === "awaiting_appointment") {
    return "awaiting_appointment";
  }

  return "pending";
};
*/

const getQuoteNumber = (ref) => {
  if (!ref) return "";
  const parts = ref.split("_");
  return parts.length > 1 ? parts[1] : ref;
};

function QuoteHeader({ quote }) {
  // const currentStatusKey = normalizeStatus(quote?.status, quote?.carworkshopStatus);
  // const currentStepIndex = STATUS_STEPS.findIndex((step) => step.key === currentStatusKey);
  // const resolvedStepIndex = currentStepIndex >= 0 ? currentStepIndex : 0;

  return (
    <div className="quote-header">
      <div className="quote-header-content">
        <a href="https://webapp.bateclick.com.br/" rel="noopener noreferrer" target="_blank">
          <img src="/bateclick.png" alt="Bateclick" className="quote-header-icon" />
        </a>
        <div className="quote-header-text">
          <h1 className="quote-header-title">Cotação {getQuoteNumber(quote.ref)}</h1>
          <p className="quote-header-subtitle">
            Criada em {new Date(quote.createdAt).toLocaleDateString("pt-BR", {
              day: "2-digit",
              month: "long",
              year: "numeric"
            })}
          </p>
        </div>
      </div>

      {/* <div className="quote-status-tracker" role="list" aria-label="Status da cotação">
        {STATUS_STEPS.map((step, index) => {
          const isComplete = index < resolvedStepIndex;
          const isCurrent = index === resolvedStepIndex;

          return (
            <div
              key={step.key}
              role="listitem"
              className={`quote-status-step${isComplete ? " is-complete" : ""}${
                isCurrent ? " is-current" : ""
              }`}
            >
              <div className="quote-status-indicator">
                <span>{index + 1}</span>
              </div>
              <span className="quote-status-label">{step.label}</span>
            </div>
          );
        })}
      </div> */}
    </div>
  );
}

export default QuoteHeader;
